export default {
  'common.roles.HieuTruong':'Hiệu trưởng',
  'common.roles.GiaoVien':'Giáo viên',
  'common.roles.PhuHuynh':'Phụ huynh',
  'common.titles.thucPham.baoCao': 'Báo cáo thực phẩm',
  'common.titles.thucPham.baoCao.so3BuocTongHop': 'Sổ ba bước tổng hợp',
  'common.titles.thucPham.baoCao.so3BuocTongHop.buoc1_1': 'Bước 1-1',
  'common.titles.thucPham.baoCao.so3BuocTongHop.buoc1_2': 'Bước 1-2',
  'common.titles.thucPham.baoCao.so3BuocTongHop.buoc2': 'Bước 2',
  'common.titles.thucPham.baoCao.so3BuocTongHop.buoc3': 'Bước 3',
  'common.titles.thucPham.baoCao.so3BuocTongHopMau2': 'Sổ ba bước tổng hợp mẫu 2',
  'common.titles.thucPham.baoCao.so3BuocTongHopMau2.buoc1_1': 'Bước 1-1',
  'common.titles.thucPham.baoCao.so3BuocTongHopMau2.buoc1_2': 'Bước 1-2',
  'common.titles.thucPham.baoCao.so3BuocTongHopMau2.buoc2': 'Bước 2',
  'common.titles.thucPham.baoCao.so3BuocTongHopMau2.buoc3': 'Bước 3',
  'common.titles.thucPham.baoCao.soTinhKhauPhanAn': 'Sổ tính khẩu phần ăn',
  'common.titles.thucPham.baoCao.soTinhKhauPhanAnMau1': 'Sổ tính khẩu phần ăn mẫu số 1',
  'common.titles.thucPham.baoCao.soTinhKhauPhanAnMau2': 'Sổ tính khẩu phần ăn mẫu số 2 (tách bữa)',
  'common.titles.thucPham.baoCao.soGiaoNhanThucPhamMau2': 'Sổ giao nhận thực phẩm',
  'common.titles.thucPham.baoCao.soCongNo': 'Sổ công nợ',
  'common.titles.thucPham.baoCao.soKho': 'Sổ kho',
  'common.titles.thucPham.baoCao.soKho.phieuXuatKho': 'Phiếu xuất kho',
  'common.titles.thucPham.baoCao.soKho.phieuXuatKhoHangCho': 'Phiếu xuất kho hàng chợ',
  'common.titles.thucPham.baoCao.soKho.phieuNhapKho': 'Phiếu nhập kho',
  'common.titles.thucPham.baoCao.soKho.phieuNhapKhoMau2': 'Phiếu nhập kho mẫu 2 (tách ngày) ',
  'common.titles.thucPham.baoCao.soKho.theoDoiXuatNhapKho': 'Phiếu theo dõi xuất nhập kho',
  'common.titles.thucPham.baoCao.soKho.soKhoTongHop': 'Sổ kho tổng hợp',
  'common.titles.thucPham.baoCao.soKho.soKhoTongHopGop': 'Sổ kho tổng hợp (gộp ngày)',
  'common.titles.thucPham.baoCao.soTaiChinh': 'Sổ tài chính',
  'common.titles.thucPham.baoCao.soTaiChinh.soQuyTienMat': 'Sổ quỹ tiền mặt',
  'common.titles.thucPham.baoCao.soTaiChinh.soThuVaThanhToan': 'Sổ thu và thanh toán',
  'common.titles.thucPham.baoCao.soTaiChinh.soTongHopThuChi': 'Sổ tổng hợp thu chi',
  'common.titles.thucPham.baoCao.soTaiChinh.soNhatKyThuVaBanGiao': 'Sổ nhật ký thu và bàn giao',
  'common.titles.thucPham.baoCao.soTaiChinh.soChiTietChi': 'Sổ chi tiết chi',
  'common.titles.thucPham.baoCao.soTaiChinh.soBaoCaoTongHopThu': 'Sổ báo cáo tổng hợp thu',
  'common.titles.thucPham.baoCao.soTaiChinh.soKeKhaiThanhToanHangThang': 'Sổ kê khai thanh toán hàng tháng',
  'common.titles.thucPham.baoCao.soBaoAnTongHop': 'Sổ báo ăn tổng hợp',
  'common.titles.thucPham.baoCao.soBaoAnTongHopMau1': 'Sổ báo ăn tổng hợp mẫu số 1',
  'common.titles.thucPham.baoCao.soBaoAnTongHopMau2': 'Sổ báo ăn tổng hợp mẫu số 2',
  'common.titles.thucPham.baoCao.soTinhTienAnTrongNgay': 'Sổ tính tiền ăn trong ngày',
  'common.titles.thucPham.baoCao.soTaiChinhCongKhai': 'Sổ tài chính công khai',
  'common.titles.thucPham.baoCao.soTaiChinhCongKhaiMau2': 'Sổ tài chính công khai mẫu số 2',
  'common.titles.thucPham.baoCao.soTaiChinhCongKhaiGop': 'Sổ tài chính công khai (gộp ngày)',
  'common.titles.thucPham.baoCao.soGiaoNhanThucPham': 'Sổ giao nhận thực phẩm',
  'common.titles.thucPham.baoCao.phieuThanhToan': 'Phiếu thanh toán',
  'common.titles.thucPham.baoCao.hoaDonBanHang': 'Hóa đơn bán hàng',
  'common.titles.thucPham.baoCao.hoaDonHangKho': 'Hóa đơn hàng kho',
  'common.titles.thucPham.baoCao.hoaDonHangCho': 'Hóa đơn hàng chợ',
  'common.titles.thucPham.baoCao.thucdonTuan': 'Thực đơn tuần',
  'common.titles.thucPham.baoCao.nhanLuuMau': 'Nhãn lưu mẫu',
  'common.titles.thucPham.baoCao.bangKeMuaHang': 'Bảng kê mua hàng',
  'common.titles.thucPham.baoCao.bangKeThucPham': 'Bảng kê thực phẩm',
  'common.titles.thucPham.baoCao.mauTheoDoiMuaLTTP': 'Mẫu theo dõi mua lương thực, thực phẩm',
  'common.titles.thucPham.baoCao.khauPhanDinhDuongKhoi': 'Khẩu phần dinh dưỡng cho khối',
  'common.titles.doanhThu.baoCao.soBanNgay': 'Bảo cáo doanh thu sở ban ngành',
  'common.buttons.dong': 'Đóng',
  'common.buttons.huy': 'Huỷ',
  'common.buttons.xoa': 'Xoá',
  'common.buttons.xuatFile': 'Xuất file',
  'common.buttons.xuatThucDonTuan': 'Xuất thực đơn tuần',
  'common.buttons.chinhSua': 'Chỉnh sửa',
  'common.buttons.xemCamera': 'Xem camera',
  'common.buttons.dongY': 'Đồng ý',
  'common.buttons.themMoi': 'Thêm mới',
  'common.buttons.luu': 'Lưu',
  'common.buttons.chay': 'Chạy',
  'common.buttons.dung': 'Dừng',
  'common.buttons.phongTo': 'Phóng to',
  'common.buttons.themPhuPhi': 'Thêm phụ phí',
  'common.buttons.xacNhan': 'Xác nhận',
  'common.buttons.tuChoi': 'Từ chối',
  'common.buttons.timKiem': 'Tìm kiếm',
  'common.buttons.themTaiKhoan': "Thêm tài khoản",
  'common.buttons.listTaiKhoan': "Danh sách tài khoản",

  'common.messages.errors.coLoiXayRa': 'Có lỗi xảy ra !',
  'common.messages.errors.luuThatBai': 'Lưu thất bại !',
  'common.messages.errors.khongTheNamTrongKhoangThoiGianKhac': 'Không thể nằm trong khoảng thời gian khác !',
  'common.messages.errors.khongNamTrongKhoangThoiGianChoPhep': 'Không nằm trong khoảng thời gian cho phép !',
  'common.messages.errors.thoiGianKetThucTruocBatDau': 'Thời gian kết thúc phải sau thời gian bắt đầu {thoiGianBatDau} !',
  'common.messages.errors.chuaCapNhatHocPhiTruong': 'Chưa cập nhật thông tin học phí trường !',
  'common.messages.errors.loiTinhHocPhi': 'Tính học phí bị lỗi !',
  'common.messages.success.taiFileThanhCong': 'Tệp tin đã tải thành công !',
  'common.messages.success.capNhatThanhCong': 'Cập nhật thành công !',
  'common.messages.success.luuThanhCong': 'Lưu thành công !',
  'common.messages.success.tinhLaiHocPhiThangTruongThanhCong': 'Đã tính lại học phí của trường tháng {thang} !',
  'common.messages.question.banCoChacMuonXoa': 'Bạn có chắc muốn xóa?',
  'common.messages.question.banCoChacMuonTuChoi': 'Bạn có chắc chắn muốn từ chối?',
  'common.labels.tongGia': 'Tổng giá',
  'common.labels.tongSo': 'Tổng số',
  'common.labels.ten': 'Tên',
  'common.labels.chiPhiDiemDanhMuon': 'Chi phí điểm danh muộn',
  'common.labels.stt': 'STT',
  'common.labels.danhSachLop': 'Danh sách lớp',
  'common.labels.vaiTro': 'Vai trò',
  'common.labels.thaoTac': 'Thao tác',
  'common.labels.thoiGianBatDau': 'Thời gian bắt đầu',
  'common.labels.thoiGianKetThuc': 'Thời gian kết thúc',
  'common.labels.giaTien': 'Giá tiền',
  'common.labels.kieuTinhTien': 'Kiểu tính tiền',
  'common.labels.donViThoiGian': 'Đơn vị thời gian',
  'common.labels.chonTruong': 'Chọn trường',
  'common.labels.chonDonVi': 'Chọn đơn vị',
  'common.labels.moTa': 'Mô tả',
  'common.labels.linkXemCamera': 'Link xem camera',
  'common.labels.linkXemCameraHD': 'Link xem camera chất lượng cao',
  'common.labels.truong': 'Trường',
  'common.labels.lop': 'Lớp',
  'common.labels.tung_khoang_thoi_gian': "Từng khoảng thời gian",
  'common.labels.thoi_luong': "Thời lượng",
  'common.labels.gio': "Giờ",
  'common.labels.phut': "Phút",
  'common.labels.hoVaTen': "Họ và tên",
  'common.labels.hoVaTenPhuHuynh': "Họ và tên phụ huynh",
  'common.labels.hoVaTenGiaoVien': "Họ và tên giáo viên",
  'common.labels.hoVaTenCon': "Họ và tên con",
  'common.labels.soDienThoai': "Số điện thoại",
  'common.labels.soCCCD': "Số CCCD/CMND/Hộ Chiếu",
  'common.labels.soDienThoaiHayUserName': "Số điện thoại (user name)",
  'common.labels.tenTaiKhoan': "Tên tài khoản",
  'common.labels.matKhau': "Mật khẩu",
  'common.labels.bietDanh': "Biệt danh",
  'common.labels.ngaySinh': "Ngày sinh",
  'common.labels.gender': "Giới tính",
  'common.labels.ngaySinhCuaBe': "Ngày sinh của bé",
  'common.labels.diaChiThuongTru': "Địa chỉ thường trú",
  'common.labels.diaChiTamTru': "Địa chỉ tạm trú",
  'common.labels.ngayHetHan': "Ngày hết hạn",
  'common.labels.maHocSinh': "Mã học sinh",
  'common.labels.email': "Email",
  'common.labels.hoTenBo': "Họ tên bố",
  'common.labels.hoTenMe': "Họ tên mẹ",
  'common.labels.namSinhBo': "Năm sinh bố",
  'common.labels.namSinhMe': "Năm sinh mẹ",
  'common.labels.sdtBo': "Số điện thoại bố",
  'common.labels.sdtMe': "Số điện thoại mẹ",
  'common.labels.danhSachCamera': 'Danh sách camera',
  'common.labels.chonCamera': 'Chọn camera',
  'common.labels.tatCaCacLopCua': 'Tất cả các lớp của {lop}',
  'common.labels.macDinh': 'Mặc định',
  'common.labels.chatLuongHD': 'Chất lượng cao',
  'common.labels.danhSachLoaiHinhDiemDanhGiaoVien': 'Loại hình điểm danh giáo viên',
  'common.labels.danhSachWifiTruong': 'Danh sách wifi',
  'common.labels.wifi': 'Wifi',
  'common.labels.gps': 'GPS',
  'common.labels.diemDanhGiaoVien': 'Điểm danh giáo viên',
  'common.labels.giaoVienDiemDanhThatBaiGuiXacNhan': 'Điểm danh thất bại (gửi yêu cầu cho hiệu trưởng xác nhận)',
  'common.labels.giaoVienDiemDanhThanhCongChoXacNhan': 'Điểm danh thành công (gửi yêu cầu cho hiệu trưởng xác nhận lại)',
  'common.labels.caiDatGiamTruHocPhi': "Cài đặt giảm trừ học phí",
  'common.labels.tenPhuPhi': "Tên phụ phí",
  'common.labels.soTien': "Số tiền",
  'common.labels.danhSachPhuPhi': 'Danh sách phụ phí',
  'common.labels.loaiPhuPhi': "Loại phụ phí",
  'common.labels.loaiPhuPhiCoDinh': "Cố định",
  'common.labels.loaiPhuPhiKhongLapLai': "Không lặp lại",
  'common.labels.loaiPhuPhiLapLai': "Lặp lại",
  'common.labels.loaiPhuPhiLapLaiKhongHan': "Lặp lại không hạn",
  'common.labels.phuPhiGiaoVien': "Tiền phụ phí",
  'common.labels.phuPhiCaNhan': "Phụ phí cá nhân",
  'common.labels.phuPhiLop': "Phụ phí",
  'common.labels.phuPhiTruong': "Phụ phí",
  'common.labels.loaiDoanhThu': "Loại doanh thu",
  'common.labels.loaiDoanhThuKhongLapLai': "Không lặp lại",
  'common.labels.loaiDoanhThuLapLai': "Lặp lại",
  'common.labels.themTaiKhoanThuTienHoc': "Thêm tài khoản thu tiền học",
  'common.labels.tenNganHang': "Tên ngân hàng",
  'common.labels.chuTaiKhoan': "Chủ tài khoản",
  'common.labels.soTaiKhoan': "Số tài khoản",
  'common.labels.danhSachLopApDung': "Danh sách lớp áp dụng",
  'common.labels.soTaiKhoanAo': "Số tài khoản ảo",
  'common.labels.trangThai': "Trạng thái",
  'common.labels.kieuThanhToan': "Kiểu thanh toán",
  'common.labels.thanhToanTruoc': "Thanh toán trước",
  'common.labels.thanhToanSau': "Thanh toán sau",
  'common.labels.phepToanCong': "+",
  'common.labels.phepToanTru': "-",
  'common.labels.kieuPhepToan': "Phép toán",
  'common.labels.xacNhan': "Xác nhận",
  'common.labels.hoTen': "Họ tên",
  'common.labels.thoiLuongTuongUng': "Thời lượng",
  'common.labels.thoiGianDiemDanhDen': "Thời gian điểm danh đến",
  'common.labels.trangThaiDiemDanhDen': "Trang thái điểm danh đến",
  'common.labels.trangThaiXinNghiPhep': "Xin nghỉ phép",
  'common.labels.trangThaiDiemDanhVe': "Trang thái điểm danh về",
  'common.labels.thoiGianDiemDanhVe': "Thời gian điểm danh về",
  'common.labels.trangThaiChamCong.DA_DI_LAM': "Đã đi làm",
  'common.labels.trangThaiChamCong.DA_DI_VE': "Đã đi về",
  'common.labels.trangThaiChamCong.KHONG_DI_LAM': "Không đi làm",
  'common.labels.trangThaiChamCong.CHO_XAC_NHAN': "Chờ xác nhận",
  'common.labels.trangThaiChamCong.CHUA_CHAM_CONG': "Chưa chấm công",
  'common.labels.trangThaiChamCong.NGHI_CO_PHEP': "Nghỉ có phép",
  'common.labels.loaiChamCong': "Loại chấm công",
  'common.labels.loaiHinhChamCongDen': "Loại hình chấm công đến",
  'common.labels.loaiHinhChamCongVe': "Loại hình chấm công về",
  'common.labels.loaiChamCong.NUA_NGAY': "Nửa ngày",
  'common.labels.loaiChamCong.CA_NGAY': "Cả ngày",
  'common.labels.album.soVideo': "Số video",
  'common.labels.album.chiTiet': "Chi tiết album ảnh {ten}",
  'common.texts.chuaCoDuLieu': "Chưa có dữ liệu",
};
